export default __webpack_public_path__ + "static/media/tituloEN.45ffd0b5.png";